export default function StatWidget({ label, value, accent = "#0ea5e9" }) {
  return (
    <div
      style={{
        background: "#0f172a",
        borderRadius: 12,
        padding: "12px 16px",
        minWidth: 120,
        border: `1px solid ${accent}44`,
        color: "white",
      }}
    >
      <div style={{ fontSize: 12, opacity: 0.7 }}>{label}</div>
      <div style={{ fontSize: 24, fontWeight: 600, color: accent }}>{value}</div>
    </div>
  );
}
